import React from 'react';
import { Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';

interface Props {
  label?: string;
  placeholder?: string;
  extra?: string;
  minimumPasswordLength?: number;
}

const recommendedPasswordLength = 8;

export function FieldPassword(props: Props) {
  const { label, placeholder, extra, minimumPasswordLength } = props;

  const passwordLength = minimumPasswordLength ?? recommendedPasswordLength;

  return (
    <Form.Item
      className="FieldPassword"
      name="password"
      label={label ?? 'Password'}
      extra={extra ?? `Your password must be at least ${passwordLength} characters long`}
      rules={[
        {
          required: true,
          min: passwordLength,
          message: `Password should be at least ${passwordLength} characters long`,
        },
      ]}
    >
      <Input.Password
        data-testid="password-input"
        prefix={<LockOutlined />}
        type="password"
        placeholder={placeholder ?? 'Type your new password and then click save'}
      />
    </Form.Item>
  );
}
